import React from 'react';
import { FormSpy } from 'react-final-form';
import composeValidators from 'utils/form';

class OnBlurValidationComponent extends React.Component {

  componentWillReceiveProps(nextProps) {
		const { schemaValidation } = this.props,
					field = this.props.active,
					{ form: { mutators }, values, form } = nextProps,
          error = composeValidators(schemaValidation, values)[field];

    if ((field && (field !== nextProps.active || (this.props.fieldValidatedOnChange && this.props.fieldValidatedOnChange.includes(field))))) {
      mutators.setError(field, [error])
    }
	}

  render() {
    return this.props.children;
	}

}

export default function onBlurValidation (props) {
  return(
    <FormSpy
      {...props}
      subscription={{ active: true, values: true, touched: true}}
      component={OnBlurValidationComponent}
    />
  )
}